<template>
  <Transition name="app-overlay">
    <div v-if="overlayVisible" class="app-overlay">
      <div class="app-overlay__content">
        <div class="spinner-border text-primary app-overlay__spinner" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p v-if="overlayText" class="app-overlay__text">{{ overlayText }}</p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useOverlay } from '@/composables/useOverlay'

const { overlayVisible, overlayText } = useOverlay()
</script>
